/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Registration_Rejection_Reason_PlaceholderInputs */

const en_admin_registration_rejection_reason_placeholder = /** @type {(inputs: Admin_Registration_Rejection_Reason_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please provide a reason...`)
};

const de_admin_registration_rejection_reason_placeholder = /** @type {(inputs: Admin_Registration_Rejection_Reason_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte geben Sie eine Begründung an...`)
};

/**
* | output |
* | --- |
* | "Please provide a reason..." |
*
* @param {Admin_Registration_Rejection_Reason_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_registration_rejection_reason_placeholder = /** @type {((inputs?: Admin_Registration_Rejection_Reason_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Registration_Rejection_Reason_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_registration_rejection_reason_placeholder(inputs)
	return en_admin_registration_rejection_reason_placeholder(inputs)
});